import styled from 'styled-components'
import { strings } from './BookBuilder.strings'
import { FormattedMessage, useIntl } from 'react-intl'
import { useCallback, useState } from 'react'
import { Button, FontSelector, Input } from '@/ui/components'
// Importing directly from the components folder to avoid circular dependencies in the manual bundle chunking process
import { Cropper } from '@/ui/components/molecules/Cropper/Cropper'
import { CustomFont } from '@/ui/pages/PreviewPDF/createPdf/types'
import { BookDefault } from '@/ui/pages/PreviewPDF/createPdf/PdfBook'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1em;
`

export interface CoverFormData {
  coverImage?: File
  coverTitle: string
  coverFont: CustomFont
  coverFontSize: number
}

interface Props {
  bookSize: BookDefault
  initialValues?: CoverFormData
  handleBack: () => void
  onSubmit: (data: CoverFormData) => void
}

export const CoverForm: React.FC<Props> = (props) => {
  const { onSubmit } = props
  const intl = useIntl()
  const [coverForm, setCoverForm] = useState<CoverFormData>({
    coverImage: props.initialValues?.coverImage,
    coverTitle: props.initialValues?.coverTitle ?? '',
    coverFont: props.initialValues?.coverFont ?? 'openSans',
    coverFontSize:
      props.initialValues?.coverFontSize ?? props.bookSize.cover.fontSize,
  })

  const handleSubmit = useCallback(
    (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault()
      onSubmit(coverForm)
    },
    [coverForm, onSubmit],
  )

  return (
    <Form onSubmit={handleSubmit}>
      <h2>
        <FormattedMessage {...strings.coverHeading} />
      </h2>
      <Input
        label={intl.formatMessage(strings.title)}
        value={coverForm.coverTitle}
        onChange={(e) =>
          setCoverForm({
            ...coverForm,
            coverTitle: e.target.value,
          })
        }
        required
      />

      <FontSelector
        initialValue={coverForm.coverFont}
        onSelect={(selected) =>
          setCoverForm({
            ...coverForm,
            coverFont: selected.value as CustomFont,
          })
        }
      />

      <Input
        label={intl.formatMessage(strings.coverFontSize)}
        type="number"
        min={12}
        max={42}
        step={2}
        value={coverForm.coverFontSize}
        onChange={(e) =>
          setCoverForm({
            ...coverForm,
            coverFontSize: Number(e.target.value),
          })
        }
      />
      <Cropper
        aspect={10 / 7}
        label={intl.formatMessage(strings.cropLabel)}
        onChange={(file) => setCoverForm({ ...coverForm, coverImage: file })}
        width="567px"
        required
      />

      <Button type="button" kind="secondary" onClick={() => props.handleBack()}>
        Back
      </Button>
      <Button type="submit" formMethod="post">
        Next
      </Button>
    </Form>
  )
}
